import React from "react";
// @ts-ignore - createPortal is available in react-dom but types may not be complete
import { createPortal } from "react-dom";

interface ConfirmModalProps {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  icon?: string;
  variant?: "danger" | "warning" | "info";
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  icon = "warning",
  variant = "danger",
  onConfirm,
  onCancel,
}) => {
  const buttonClass = variant === "danger" ? "red" : variant === "warning" ? "orange" : "blue";

  const modalContent = (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content confirm-modal animate__animated animate__fadeIn" onClick={(e) => e.stopPropagation()}>
        <div className={`confirm-modal__icon confirm-modal__icon--${variant}`}>
          <span className="material-symbols-outlined notranslate">{icon}</span>
        </div>
        <h2 className="confirm-modal__title">{title}</h2>
        <p className="confirm-modal__message">{message}</p>
        <div className="confirm-modal__actions">
          <button onClick={onCancel} className="btn light-gray confirm-modal__button">
            {cancelText}
          </button>
          <button onClick={onConfirm} className={`btn ${buttonClass} confirm-modal__button`}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default ConfirmModal;
